import React from 'react'
import { Button, IconPath } from '@nespresso-design-system/components'
import { CTA as CTAProps } from '@commons/drupal.types'
import { selectPromotion } from '@content/helpers/src/gtmEvents'
import { CampaignProps } from '@commons/types'
import ctaAdditionalStyles from '@commons/cta/cta.additional.module.scss'

const CTA = ({
    contrast,
    disabled = false,
    link,
    config,
    isDecorative = false,
    isLoading = false,
    label,
    size,
    variant,
    aria_label_before,
    aria_label_after,
    tracking_select_promotion,
    campaign,
    defaultVariant,
    defaultContrast,
    icon,
    onClick
}: CTAProps & {
    tracking_select_promotion?: string
    campaign?: CampaignProps
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}) => {
    if (!label) {
        return null
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (disabled) return

        if (tracking_select_promotion && campaign) {
            selectPromotion({
                cta_name: tracking_select_promotion,
                ...campaign
            })
        }

        onClick?.(event)
    }
    return (
        <Button
            contrast={contrast ?? defaultContrast}
            disabled={disabled}
            href={link}
            icon={(config?.icon as IconPath) || (icon as IconPath)}
            iconPosition={config?.iconPosition}
            isDecorative={isDecorative}
            isLoading={isLoading}
            label={label}
            size={size || 'medium'}
            variant={config?.variant || variant || defaultVariant}
            aria-label={aria_label_before || aria_label_after}
            className={`${config?.className || ''} ${disabled ? ctaAdditionalStyles['cta__is-disabled'] : ''}`}
            onClick={handleClick}
        />
    )
}

export default CTA
